// @fixme this should be renamed all-together - main functionality is MENU, which is separate script ... etc. Fun stuff
// PS: this is basically same functionality ad Drop-block.js ...
// @todo merge those two into one component
// @todo handle closing sub-submenus maybe differently

import 'ui-core/plugins/drawer/js/drawer';

(function (UX) {
    var $body = $('body'),
        isMobile = false,
        elements = document.querySelectorAll('.menu-item'),
        controlSelector = null,
        menubar = null,
        isOpen = null;

    var menu = UX.menu;

    menu.init = function () {
        // removing old Menubar basically
        // rest of this should be refactored

        var $menubar = $('.main-nav');
        $menubar.each(function (index) {
            menu.$target = $(this);
            menu.check.viewPort(index);
            menu.responsive(index);
        });
        menu.items = $menubar.find('a, button, input'); //$(".header__nav a, .header__nav button, .header__nav input");
        menu.control();
        menu.additionalControl();
        menubar.init();

        const menuIcon = document.querySelector('.main-nav a[href="#menuBook"]');
        menuIcon?.remove();

        elements?.forEach(menuItem => {
            const menuLink = menuItem?.querySelector('a[href$="-pane"]');
            menuLink?.removeAttribute('aria-selected');
        });
    };

    // remove UX lvl functions
    menu.on.tabDesktop = function () {};
    menu.on.tabReversDesktop = function () {};
    menu.on.escDesktop = function () {};

    // menubar control selector constant
    controlSelector = '[data-toggle="dropdown"]:not(.expandable-list__toggle)';

    menubar = {
        vPort: 'screen-sm',

        init: function () {
            menubar.prepare();
            menubar.switchMobileFlag();
            menubar.accessibility.control();
        },
        prepare: function () {
            $('nav').data('flag-open', false);
        },

        /**
         * Accessibility for menubar
         * @namespace
         */
        accessibility: {
            /**
             *
             */
            _flagReverseOrder: false,

            control: function () {
                // Focusout for closing menu is handled by controller.js
                // ESC key is handled by controller.js

                var $this = null,
                    menuId = null,
                    preventDefault = null,
                    flagOpen = null,
                    flagChangeFocus = null,
                    isNested = null,
                    isControl = null,
                    action = null,
                    params = null,
                    isSub = null;

                $(document)
                    .on('click', controlSelector, function (event, forceOpen) {
                        if (isMobile) {
                            return;
                        }

                        $this = $(this);
                        isOpen = $this.hasClass('js--open');

                        // Controller - save component state
                        menubar.$controller = $this;
                        menubar.findTarget();
                        // show current menu on focus when allowed by flag
                        if (isOpen && !forceOpen) {
                            menubar.on.hide(event);
                        } else {
                            menubar.on.show(event);
                        }

                        // Reset flags
                        menubar.$container.data('flag-open', false);
                        menubar.$container.data('flag-change-focus', false);

                        // Change focus if triggered by JS
                        if (!event.originalEvent) {
                            $this.focus();
                        }
                    })
                    .on('focus', '[role="menuitem"]', function (event, forceOpen) {
                        $this = $(this);

                        menubar.$container = $(this).closest('nav');
                        menubar.itemsCollection = menubar.$container.find('[role="menuitem"]');

                        menuId = $this.closest('[role=menu]').attr('id');

                        // collection based on type form [role=menuitem] collection for this menu
                        menubar._menubarContext_itemsCollection = menubar.itemsCollection.filter(
                            '[role=menubar] > li > [role=menuitem]'
                        ); // lvl0
                        // Default selection of context - can be changed in SWITCH for some cases to menubar context

                        menubar._currentContext_isSub = menubar._menubarContext_itemsCollection.index($this) < 0;

                        if (menubar._currentContext_isSub && $(this).closest('.hubpage-menu__nav').length) {
                            menubar._currentContext_itemsCollection = menubar.itemsCollection.filter(
                                '#' + menuId + '  li  [role=menuitem]'
                            );
                        } else if (menubar._currentContext_isSub) {
                            menubar._currentContext_itemsCollection = menubar.itemsCollection.filter(
                                '#' + menuId + ' > li > [role=menuitem]'
                            ); // lvl1-...
                        } else {
                            menubar._currentContext_itemsCollection = menubar._menubarContext_itemsCollection;
                        }

                        menubar._currentIndex = menubar._currentContext_itemsCollection.index($this);

                        // reverse order
                        menubar.accessibility._flagReverseOrder = $this.css('direction') === 'rtl';
                    })
                    .on('focus', controlSelector, function () {
                        // if (menubar.$container.data('flag-open')) {
                        //     $(this).click();
                        // }
                        //@todo: this event causing infinite code calling (Maximum call stack size exceeded error) and need to re-check.
                    })
                    .on('keydown', '[role="menuitem"]', function (event) {
                        var keyCodes = {
                            DOWN: 40,
                            END: 35,
                            HOME: 36,
                            LEFT: 37,
                            RIGHT: 39,
                            UP: 38,
                            RETURN: 13,
                            SPACE: 32,
                            TAB: 9,
                            ESCAPE: 27,
                        };

                        // don't prevent default for not allowed keys (exception here is printable Characters for searching, so flag is reset later)
                        preventDefault = true;
                        if (!(Object.values(keyCodes).indexOf(event.keyCode) > -1)) preventDefault = false;

                        // Flags for opening menu
                        flagOpen = false;
                        flagChangeFocus = false;

                        $this = $(this);

                        isNested = false;

                        isControl = $this.is(controlSelector);

                        if ($this.parents('[role=menu]').length > 1) {
                            isNested = true;
                        }

                        action = null;
                        params = null;

                        isSub = menubar._currentContext_isSub;

                        function isPrintableCharacter(str) {
                            return str.length === 1 && str.match(/\S/);
                        }

                        if (isMobile) {
                            switch (event.keyCode) {
                                case keyCodes.LEFT:
                                case keyCodes.ESCAPE:
                                    flagChangeFocus = false;
                                    $this.parents('li').last().find('[role=menuitem]').focus();
                                    action = 'close';
                                    preventDefault = true;
                                    break;
                                case keyCodes.RETURN:
                                case keyCodes.SPACE:
                                    // leave opening and closing to default click event
                                    action = 'open';
                                    // change focus if it was control element - it will be ignored otherwise
                                    flagChangeFocus = true;
                                    break;
                                case keyCodes.TAB:
                                    // reset flags on TAB for current menubar and do nothing else - leave that to default focus handler
                                    preventDefault = false;
                                    break;
                                // Arrows - here we go with keyboard logic
                                case keyCodes.UP:
                                    if (!isControl && isSub) {
                                        $this.parents('li').last().find('[role=menuitem]').focus();
                                    } else {
                                        menubar._currentContext_itemsCollection =
                                            menubar._menubarContext_itemsCollection;
                                        menubar._currentIndex = UX.menubar._menubarContext_itemsCollection.index(
                                            $this.parents('li').last().find('[role=menuitem]')
                                        );
                                    }
                                    action = 'prev';
                                    break;
                                case keyCodes.END:
                                    action = 'end';
                                    break;
                                case keyCodes.HOME:
                                    action = 'home';
                                    break;
                                case keyCodes.DOWN:
                                    if (!isControl && isSub) {
                                        $this.parents('li').last().find('[role=menuitem]').focus();
                                    } else {
                                        menubar._currentContext_itemsCollection =
                                            menubar._menubarContext_itemsCollection;
                                        menubar._currentIndex = UX.menubar._menubarContext_itemsCollection.index(
                                            $this.parents('li').last().find('[role=menuitem]')
                                        );
                                    }
                                    action = 'next';

                                    break;
                                case keyCodes.RIGHT:
                                    if (isControl && !isSub) {
                                        flagChangeFocus = true;
                                        action = 'open';
                                    }
                                    break;
                                default:
                                    if (isPrintableCharacter(event.key)) {
                                        action = 'find';
                                        params = [event.key];
                                        preventDefault = true;
                                    }
                            }
                            // return;
                        } // @fixme this will be removed after adding support for vertical menus too
                        else {
                            // Navigation switch
                            // @todo change behavior for isMobile - because mainmenu becomes horizontal ...
                            switch (event.keyCode) {
                                case keyCodes.RETURN:
                                case keyCodes.SPACE:
                                    // leave opening and closing to default click event
                                    action = 'open';
                                    // change focus if it was control element - it will be ignored otherwise
                                    flagChangeFocus = true;
                                    break;
                                case keyCodes.TAB:
                                    // reset flags on TAB for current menubar and do nothing else - leave that to default focus handler
                                    preventDefault = false;
                                    break;
                                // Arrows - here we go with keyboard logic
                                case keyCodes.UP:
                                    // Key UP doesn't have any difference in design pattern
                                    action = 'prev';
                                    break;
                                case keyCodes.LEFT:
                                    if ((!isControl && isNested && isSub) || (isSub && !isNested && !isControl)) {
                                        menubar._currentContext_itemsCollection =
                                            menubar._menubarContext_itemsCollection;
                                        menubar._currentIndex = UX.menubar._menubarContext_itemsCollection.index(
                                            $this.parents('li').last().find('[role=menuitem]')
                                        );
                                        action = 'prev';
                                    } else {
                                        // we move to parent control
                                        menubar._currentContext_itemsCollection =
                                            menubar._menubarContext_itemsCollection;
                                        menubar._currentIndex = UX.menubar._menubarContext_itemsCollection.index(
                                            $this.parents('li').last().find('[role=menuitem]')
                                        );
                                        action = 'prev';
                                    }
                                    if ((!isControl && isSub && isNested) || (isSub && isNested && isControl)) {
                                        action = 'close';
                                    }
                                    break;
                                case keyCodes.END:
                                    action = 'end';
                                    break;
                                case keyCodes.HOME:
                                    action = 'home';
                                    break;
                                case keyCodes.RIGHT:
                                    if (isControl && isSub) {
                                        // open submenu
                                        flagChangeFocus = true;
                                        action = 'open';
                                    } else {
                                        menubar._currentContext_itemsCollection =
                                            menubar._menubarContext_itemsCollection;
                                        menubar._currentIndex = UX.menubar._menubarContext_itemsCollection.index(
                                            $this.parents('li').last().find('[role=menuitem]')
                                        );
                                        action = 'next';
                                    }
                                    if (isSub && !isControl) {
                                        flagOpen = true;
                                        flagChangeFocus = true;
                                    }
                                    break;
                                case keyCodes.DOWN:
                                    if (isControl && !isSub) {
                                        flagChangeFocus = true;
                                        action = 'open';
                                    } else {
                                        action = 'next';
                                    }
                                    break;
                                default:
                                    if (isPrintableCharacter(event.key)) {
                                        action = 'find';
                                        params = [event.key];
                                        preventDefault = true;
                                    }
                            }
                        }

                        // prevent menu from opening or allow it to open on focus based on flag
                        menubar.$container.data('flag-open', flagOpen);
                        menubar.$container.data('flag-change-focus', flagChangeFocus);

                        // call action
                        if (action) menubar.accessibility.menuitem($this, action, params);

                        // stop page from scrolling, while we handle navigation by keys
                        if (preventDefault) {
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    });
                $('#menubar').on('focusout', function (e, index) {
                    if (!$(e.relatedTarget).parents().is($(this))) {
                        $(this)
                            .find('.dropdown__toggle.js--open.hover')
                            .removeClass('js--open hover')
                            .attr('tabindex', '-1')
                            .next('.dropdown__menu.js--open')
                            .attr('aria-hidden', 'true')
                            .removeClass('js--open');
                    }
                });

                $body.off('touchend', '[data-toggle="dropdown"]');
            },

            /**
             * Handle menu item - mixed methods
             * @param {jQuery} $item
             * @param {('next'|'prev'|'home'|'end'|'find'|'close'|'open')} [action] - available methods
             * @param {Array} params
             * @public
             */
            menuitem: function ($item, action, params) {
                var length = menubar._currentContext_itemsCollection.length;
                var currentIndex = menubar._currentIndex;

                var actions = {
                    /**
                     * Next
                     * @param {jQuery} $item
                     * @private
                     */
                    next: function ($item) {
                        this.goTo(currentIndex + 1);
                    },
                    prev: function ($item) {
                        this.goTo(currentIndex - 1);
                    },
                    find: function ($item, params) {
                        // @todo search for item start with character and go to it in current context
                    },
                    home: function () {
                        this.goTo(0);
                    },
                    end: function () {
                        this.goTo(length - 1);
                    },
                    goTo: function (index) {
                        // circle
                        if (index < 0) {
                            index = length - 1;
                        }
                        if (index >= length) {
                            index = 0;
                        }
                        $('.main-nav').find('.is--current').removeClass('is--current');
                        // focus to target
                        menubar._currentContext_itemsCollection.eq(index).focus().parent('li').addClass('is--current');
                        menubar.closeInactiveSubMenu(index);
                    },
                    open: function ($item) {
                        if ($item.is(controlSelector)) {
                            $item.trigger('click', true);
                        } else {
                            // real click on items that are not controls, to avoid issues with default prevented
                            $item[0].click();
                        }

                        $item.next().find('li:first-child a').focus();
                    },
                    close: function ($item) {
                        // @todo maybe selector would be better than .prev() method
                        $item.closest('[role=menu]').prev().focus().click();
                    },
                };

                // Reverse order
                if (this._flagReverseOrder) {
                    switch (action) {
                        case 'prev':
                            action = 'next';
                            break;
                        case 'next':
                            action = 'prev';
                            break;
                        case 'home':
                            action = 'end';
                            break;
                        case 'end':
                            action = 'home';
                            break;
                    }
                }

                // actions logic
                if (typeof action === 'string') {
                    if (typeof actions[action] === 'undefined') {
                        throw new TypeError('No method named "' + action + '" found.');
                    }
                    actions[action]($item, params);
                }
            },
        },
        switchMobileFlag: function () {
            $(document).on(menubar.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                isMobile = true;
            });
            $(document).on(menubar.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                isMobile = false;
            });
        },
        closeInactiveSubMenu: function (index) {
            let navclass = 'main-nav';
            if (menubar._currentContext_itemsCollection.eq(index).parent().parent().parent().is('.hubpage-menu__nav')) {
                navclass = 'hubpage-menu__nav';
            }
            if (
                (menubar._currentContext_itemsCollection.eq(index).parent().parent().is('.menubar') ||
                    menubar._currentContext_itemsCollection
                        .eq(index)
                        .parent()
                        .parent()
                        .parent()
                        .is('.hubpage-menu__nav')) &&
                $('.' + navclass).find('.dropdown__toggle.js--open.hover').length
            ) {
                $('.' + navclass)
                    .find('.dropdown__toggle.js--open.hover')
                    .removeClass('js--open hover')
                    .attr('tabindex', '-1')
                    .next('.dropdown__menu.js--open')
                    .attr('aria-hidden', 'true')
                    .removeClass('js--open');
            }
        },
        findTarget: function () {
            var $target = $('#' + menubar.$controller.attr('data-target')),
                $nested = null;

            if (!$target.length) {
                $target = $(menubar.$controller.attr('href'));
            }
            if (!menubar.$controller.attr('data-target') && menubar.$controller.attr('data-slide-target')) {
                $target = $(menubar.$controller.attr('data-slide-target'));
            }
            menubar.$section = $target;

            menubar.$container = menubar.$section.closest('nav');

            $nested = menubar.$section.parents('[role="menu"]');

            // Controller closing handling of children
            if ($nested.length) {
                menubar.$parentSection = $nested;
            } else {
                menubar.$parentSection = null;
            }
        },
        on: {
            show: function (event) {
                // Controller handling START:
                // @todo refactor this behavior too ...
                if (!menubar.$controller.closest('[role=menu]').length) {
                    if (typeof UX.controller !== 'undefined') {
                        UX.controller.check();
                    }
                }
                // --- :END

                if (menubar.$section) {
                    menubar.$section.addClass('js--open');
                    menubar.$controller.addClass('js--open');
                    // @todo refactor this behavior too ...
                    menubar.$controller.addClass('hover');
                    // Controller handling active component save
                    $body.attr('data-active', 'menubar');
                    if (isMobile) {
                        $body.addClass('lock-screen');
                    }

                    // @see https://www.w3.org/TR/wai-aria-practices/#kbd_roving_tabindex
                    if (menubar._currentContext_itemsCollection === menubar._menubarContext_itemsCollection) {
                        // remove tabindexes
                        menubar._menubarContext_itemsCollection?.attr('tabindex', -1);
                        menubar._menubarContext_itemsCollection?.eq(0).attr('tabindex', 0);
                        // set tabindex for new item and move focus to target
                        menubar.$controller?.attr('tabindex', 0);
                    }

                    // Change focus to fist item in list
                    if (menubar.$container.data('flag-change-focus')) {
                        // HAS TO USE TIMEOUT DOU TO MENU TRANSITION
                        setTimeout(function () {
                            menubar.$section.find('[role=menuitem]').first().focus();
                        }, 15);
                    }

                    // Accessibility
                    menubar.$controller.attr({'aria-expanded': 'true'});
                    menubar.$section.removeAttr('aria-hidden');
                }
            },
            hide: function () {
                var $target = null;

                if (menubar.$section) {
                    // Close current target
                    menubar.$controller.removeClass('js--open');
                    menubar.$section.removeClass('js--open');
                    // @todo refactor this behavior too ...
                    menubar.$controller.removeClass('hover');

                    // Accessibility - Inform screen readers
                    menubar.$controller.attr({'aria-expanded': 'false'});
                    menubar.$section.attr({'aria-hidden': 'true'});

                    // Controller handling
                    // Nested dropBlocks close handling
                    if (menubar.$parentSection && menubar.$parentSection.length) {
                        // Nested ones - set parent after closing self - will close parent in second round
                        $target = $('[data-target=' + menubar.$parentSection.attr('id') + ']');
                        if (!$target.length) {
                            $target = $('[href=' + '#' + menubar.$parentSection.attr('id') + ']');
                        }
                        menubar.$controller = $target;
                        menubar.findTarget();
                    } else {
                        // If we want to close last menu, than there is no more active component
                        if ($body.attr('data-active') === 'menubar') {
                            $body.removeAttr('data-active');
                            if (isMobile) {
                                $body.removeClass('lock-screen');
                            }
                        }
                    }
                }
            },
        },
    };

    UX.menubar = menubar;

    elements.forEach(function (element) {
        if (getComputedStyle(element).display === 'none') {
            element.remove();
        }
    });
})(UX);

UX.menu.additionalControl = function () {
    const menuParentList = Array.from(document.querySelectorAll('.menu-parent'));
    menuParentList.map(item => {
        item.querySelector('ul')?.addEventListener('mousedown', e => {
            e.preventDefault();
        });
    });
    //commented these lines because additionalControl already wasn't called
    // var isOpen = null;
    //
    // $('body').on('click', 'li.dropdown', function (e) {
    //     if (!UX.menu.isMobile) {
    //         isOpen = false;
    //
    //         if ($(this).hasClass('js--open')) {
    //             isOpen = true;
    //         }
    //
    //         $('li.dropdown').removeClass('js--open');
    //         $('.dropdown__toggle').removeClass('hover');
    //
    //         if (!isOpen) {
    //             $(this).addClass('js--open').children('.dropdown__toggle').addClass('hover');
    //         }
    //     }
    // });
    //
    // $(document).on('click', function (e) {
    //     if (
    //         !$(e.target).is('.dropdown.menu-parent') &&
    //         !$(e.target).closest().is('.dropdown.menu-parent') &&
    //         $('.dropdown.menu-parent').hasClass('js--open')
    //     ) {
    //         $('.dropdown.menu-parent').removeClass('js--open');
    //     }
    // });
    UX.utils.menuRoleButton();
};

UX.menu.on.showAdditional = function () {
    var isMenuOpen = $('body').data('active') === 'menu' ? true : false;
    if (isMenuOpen) {
        $('html').css('overflow', 'visible');
    }
};
